import React from "react";
import { useEffect, useRef, useState } from "react";

interface TurnstileWidgetProps {
    siteKey: string;
}
const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({ siteKey }) => {

    const widgetRef = useRef(null);
    const [token, setToken] = useState("");

    useEffect(() => {
        const renderTurnstile = () => {
        if (window.turnstile && widgetRef.current) {
            window.turnstile.render(widgetRef.current, {
            sitekey: siteKey,
            callback: (token) => {
                setToken(token);
                document.getElementById("turnstile-token").value = token;
            },
            "expired-callback": () => {
                setToken("");
                document.getElementById("turnstile-token").value = "";
                document.getElementById("turnstile-error").style.display = "block";
            },
            });
        }
        };

        if (window.turnstile) {
        renderTurnstile();
        } else {
        window.onTurnstileLoad = renderTurnstile;
        }
    }, [siteKey]);

    return (
        <>
        <input type="hidden" name="turnstileSiteKey" id="turnstileSiteKey" value={siteKey} />
        <div ref={widgetRef} className="cf-turnstile" ></div>
        <input type="hidden" id="turnstile-token" name="cf-turnstile-response" value={token} />

        <div id="turnstile-error" style={{ display: "none", color: "red" }}>
            CAPTCHA expired. Please try again.
        </div>
        </>
    );
};

export default TurnstileWidget;